import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { formValueSelector } from 'redux-form';

import ModalInstructions from 'components/ModalInstructions';
import MustHaveReadText from 'components/MustHaveReadText';
import LocalisedMessage from 'components/Common/LocalisedMessage';

import ModalWrapper from 'components/Modals/ModalWrapper';

const PenaltiesOfPerjuryModal = ({
  formType,
  onConfirm,
  onCancel,
  subjectToBackupWithholding,
  formGroup,
  intl,
  isCertifyingForm
}) => {
  const [allRead, setAllRead] = useState(false);
  const modalInstruction = ModalInstructions(formType ?? formGroup.key, subjectToBackupWithholding);
  return (
    <ModalWrapper
      title={ <h1><LocalisedMessage id="certification.title" /></h1> }
      closeButtonName={ intl.formatMessage({ id: 'certification.title' }) }
      disableConfirm={ !allRead || isCertifyingForm }
      showCancel={ false }
      btnConfirmTitle={ intl.formatMessage({ id: 'certification.buttons.agree' }) }
      content={ modalInstruction?.CertificationContent
        && <MustHaveReadText
          content={ modalInstruction.CertificationContent }
          IsTextRead={ value => setAllRead(value) }
        /> }
      footer={ !allRead ? intl.formatMessage({ id: 'certification.footer.proceedText' }) : <LocalisedMessage id="certification.footer.declarationText" /> }
      onConfirm={ () => { onConfirm(); } }
      onCancel={ () => { onCancel(); } }
      id="certification-modal"
    />
  );
};

PenaltiesOfPerjuryModal.propTypes = {
  formType: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  subjectToBackupWithholding: PropTypes.bool,
  formGroup: PropTypes.shape({
    key: PropTypes.string,
    formTypes: PropTypes.arrayOf(PropTypes.string)
  }),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  isCertifyingForm: PropTypes.bool
};

PenaltiesOfPerjuryModal.defaultProps = {
  subjectToBackupWithholding: false,
  formType: null,
  formGroup: null,
  isCertifyingForm: false
};

function mapStateToProps(state) {
  const selector = formValueSelector('w9-form');
  const {
    form: { isCertifyingForm },
    questionnaires: { formQuestionnaire }
  } = state;

  return {
    isCertifyingForm,
    subjectToBackupWithholding: formQuestionnaire?.answers?.signer?.subjectToBackupWhd ?? selector(state, 'certification.subjectToBackupWithholding')
  };
}

export default connect(
  mapStateToProps,
)(injectIntl(PenaltiesOfPerjuryModal));
